import { render, staticRenderFns } from "./DetailProdSlitting.vue?vue&type=template&id=da08d104&scoped=true&"
import script from "./DetailProdSlitting.vue?vue&type=script&lang=js&"
export * from "./DetailProdSlitting.vue?vue&type=script&lang=js&"
import style0 from "./DetailProdSlitting.vue?vue&type=style&index=0&id=da08d104&lang=scss&scoped=true&"
import style1 from "./DetailProdSlitting.vue?vue&type=style&index=1&id=da08d104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da08d104",
  null
  
)

export default component.exports